import React, { useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import Sidebar from "./components/layout/Sidebar";

// PAGES
import Dashboard from "./pages/fleetOverview/Dashboard";
import ReserveBooking from "./pages/reserve/ReserveBooking";
import { LocationsPricing } from "./pages/locationPricing/LocationsPricing";
import ManageVehicles from "./pages/manageVehicles/ManageVehicles";
import ManageVehiclesDriver from "./pages/manageVehicleDriver/ManageVehiclesDriver";
import GateCode from "./pages/gateCode/GateCode";
import BookingHistory from "./pages/bookingHistory/BookingHistory";
import DriverActivityPage from "./pages/driverActivity/DriverActivityPage";
import EntryExit from "./pages/entryExit/EntryExit";
import LiveCameraPage from "./pages/liveCamera/LiveCameraPage";
import BillingPage from "./pages/billingPage/BillingPage";
import AlertPreferences from "./pages/alertPreferences/AlertPreferences";

import LoginPage from "./auth/Login";
import PrivateRoute from "./auth/PrivateRoute";
import { AlertContainer } from "./components/common/Alert";
import SupportPage from "./pages/support/SupportPage";
import { GiHamburgerMenu } from "react-icons/gi";
import { Button } from "react-bootstrap";
import Payment from "./pages/payments/Payment";
import { ForgotPassword } from "./auth/ForgotPassword";
import { ResetPassword } from "./auth/ResetPassword";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
        <AlertContainer />

      <Routes>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/*" element={<PrivateRoute>
          <div className="app-layout">
            <Sidebar
              isOpen={sidebarOpen}
              closeSidebar={() => setSidebarOpen(false)}
            />

            {sidebarOpen && (
              <div
                className="sidebar-overlay"
                onClick={() => setSidebarOpen(false)}
              />
            )}

            <div className="main-content">
              <div className="mobile-header d-md-none">
                <Button className='border-primary' variant="transparent" onClick={() => setSidebarOpen(true)}><GiHamburgerMenu  size={23} className="pb-1 text-primary"/></Button>
              </div>

              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/reserve-booking" element={<ReserveBooking />} />
                <Route path="/location-pricing" element={<LocationsPricing />} />
                <Route path="/manage-vehicles" element={<ManageVehicles />} />
                <Route path="/manage-vehicles-driver" element={<ManageVehiclesDriver />} />
                <Route path="/access-control" element={<GateCode />} />
                <Route path="/booking-history" element={<BookingHistory />} />
                <Route path="/driver-activity" element={<DriverActivityPage />} />
                <Route path="/entry-exit" element={<EntryExit />} />
                <Route path="/live-camera" element={<LiveCameraPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/transactions" element={<Payment/>} />
                <Route path="/alert-preferences" element={<AlertPreferences />} />
                <Route path="/support" element={<SupportPage />} />
              </Routes>
            </div>
          </div>
        </PrivateRoute>
        }
        />

      </Routes>
    </Router>
  );
}

export default App;